import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faSave,
  faSearch,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowDown,
} from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tooltip";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Transportation.css";
import "../../Shared/Searchbar.css"; // Import your CSS file
import GoCast from "../../Images/GoCast.png";
import { useParams, useNavigate,useLocation } from 'react-router-dom';

function TransportationDetails_Dashboard() {

  const GoBack = () => {
    navigate(-1); // Navigates back to the previous page
  };

  // Loading GIF
  const [isLoading, setIsLoading] = useState(false);
  // Search-bar
  const [searchOpen, setSearchOpen] = useState(false);
  // Table visibility
  const [tableVisible, setTableVisible] = useState(true);

  const [selectedFilter, setSelectedFilter] = useState("");

  // // Filter Second Grid By Taking The Load ID & Filter in Second API
  // const [selectedLoadID, setSelectedLoadID] = useState(null);

    const navigate = useNavigate();
 
    // Takes Parametres from URL and save it to Variables
    // Returns Dynamic Parameter from TruckForm :truckId
    const { transportid } = useParams();

  // Search Toggle
  const toggleSearch = () => {
    setSearchOpen(!searchOpen);
  };

  // Toggle table visibility
  const toggleTableVisibility = () => {
    setTableVisible(!tableVisible);
  };

  //        API CODE
  const [apiData1, setApiData1] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Adjust this number as needed

  const fetchData = async () => {
    setIsLoading(true); // Load GIF
    const username = "manager"; // Replace with your username
    const password = "manager"; // Replace with your password
    const apiUrl2 = `https://77.92.189.102/iiprecastverticaldemo/api/v1/BaqSvc/IIT_TransportationDtlsDB(PRECAST)?$filter= UD103_Key1 eq '${transportid}'`; // Adjust the URL as needed

    try {
      const response = await fetch(apiUrl2, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic " + btoa(username + ":" + password),
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok for Grid 1");
      }
      ////////////////////////// Grid 1 Data /////////////////////////////////
      const data = await response.json();
      // Check if data is an object and contains the 'value' property which is an array
      if (
        typeof data === "object" &&
        data !== null &&
        Array.isArray(data.value)
      ) {
        setApiData1(data.value);
        setIsLoading(false); // Loading GIF
      } else {
        console.error(
          'API response does not contain the expected array in the "value" property:',
          data
        );
      }
    } catch (error) {
      console.error("There was a problem with your fetch operation:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []); // Fetch data on component mount

  const renderTableRows2 = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentItems = apiData1.slice(startIndex, endIndex);
    return currentItems.map((item, index) => (
      <tr key={index}>
        <td>{item.UD103_Key1}</td>
        <td>{item.UD103_Date01}</td>
        <td>{item.UD103A_Character01}</td>
        <td>{item.UD103A_Character02}</td>
        <td>{item.UD103A_ShortChar07}</td>
        <td>{item.Calculated_QtyUOM}</td>
        <td>{item.PartLot_Ton_c}</td>
        <td>{item.UD103_ShortChar05}</td>
        <td>{item.UD103_Date02}</td>
        <td>{item.UD103_ShortChar01}</td>
        <td>{item.Warehse_Description}</td>
        <td>{item.UD103A_Character04}</td>
        <td>{item.Warehse1_Description}</td>
        <td>{item.UD103_Character04}</td>
        <td>{item.ProdGrup_Description}</td>
        <td>{item.UD103A_Number06}</td>
      </tr>
    ));
  };
  const goToNextPage = () => {
    const totalPages = Math.ceil(apiData1.length / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNextPage1 = () => {
    const totalPages = Math.ceil(apiData1.length / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPreviousPage1 = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  return (
    <div className="TruckMastertable">
      {isLoading && (
        <div className="loading-overlay">
          <img src={GoCast} alt="Loading..." />
        </div>
      )}

      <div className="card rebartable">
        <div className="card-header">
          <button
            type="button"
            className="toggle-table-icon"
            onClick={GoBack}
          >
            <FontAwesomeIcon icon={faArrowLeft}/>
          </button>
          <h2 className="panel-title">Details</h2>
        </div>
        {/* Conditionally render the table */}
        {tableVisible && (
          <div className="card-body">
            <div class="table-responsive">
              <div className="scrollable-table-body">
                <table className="table table-bordered">
                  {/* Table content */}
                  <thead className="table-primary">
                    <tr className="bg-primary text-white text-nowrap">
                      <th>Load</th>
                      <th>Loading Date</th>
                      <th>PartNum</th>
                      <th>Element Num</th>
                      <th>UOM</th>
                      <th>Qty</th>
                      <th>Ton</th>
                      <th>Project</th>
                      <th>Offload Date</th>
                      <th>Delivery Type</th>
                      <th>From Stockyard</th>
                      <th>From Bin</th>
                      <th>To Stockyard</th>
                      <th>To Bin</th>
                      <th>Product Group</th>
                      <th>Erection Seq</th>
                    </tr>
                  </thead>
                  <tbody>{renderTableRows2()}</tbody>
                </table>
              </div>
            </div>
            <div className="pagination">
              <button onClick={goToPreviousPage1} disabled={currentPage === 1}>
                <FontAwesomeIcon icon={faArrowLeft} />
              </button>
              <button
                onClick={goToNextPage1}
                disabled={
                  currentPage === Math.ceil(apiData1.length / itemsPerPage)
                }
              >
                <FontAwesomeIcon icon={faArrowRight} />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TransportationDetails_Dashboard;
